import React, { useRef } from 'react';

import styled from 'styled-components';

import { FormattedMessage } from '@techstyle/react-intl';

import { desktop, mobile, mobileDevice, tabletDevice } from '../../styles';
import { CartDrawerPromoCode } from '../CartDrawerPromoCode/CartDrawerPromoCode';
import StaticIcon from '../StaticIcon/StaticIcon';

import { CartDrawerPaypalButton } from './CartDrawerPaypalButton';
import { NewCartDrawerSummary } from './NewCartDrawerSummary';

const FooterWrapper = styled.div`
  position: relative;
  padding: 0 ${({ theme }) => theme.spacing.small}px
    ${({ theme }) => theme.spacing.small}px
    ${({ theme }) => theme.spacing.small}px;
  ${desktop`
    margin-top: auto;
  `}
  ${tabletDevice`
    margin-top: auto;
  `}
  ${mobileDevice`
    padding: 18px 0;
  `}
`;

const CheckoutButtonWrapper = styled.div<{
  showOutOfStockLabel?: boolean;
}>`
  margin: ${({ theme }) => theme.spacing.moderate}px 0
    ${({ theme }) => theme.spacing.small}px 0;
  ${({ showOutOfStockLabel }) => showOutOfStockLabel && `margin-bottom: 4px;`}
`;

const CartDrawerPromoCodeWrapper = styled.div`
  ${desktop`
    padding: ${props => `${props.theme.spacing.small}px 0 0`};
  `}
`;

const ErrorMessage = styled.p`
  ${({ theme }) => theme.paragraph.variants.paragraph4.textStyles};
  text-transform: none;
  color: ${({ theme }) => theme.colors.error};
  padding-left: 6px;
  line-height: 14px;
`;

const OutOfStockWrapper = styled.div`
  display: flex;
  ${mobile`
    padding: 0 ${({ theme }) => theme.spacing.small}px;
  `}
`;

const ErrorIcon = styled(StaticIcon)`
  fill: ${({ theme }) => theme.colors.red500};
`;

export function CartDrawerExpandedFooter({
  checkoutButton,
  showOutOfStockLabel,
}) {
  const ref = useRef<HTMLDivElement | null>(null);

  return (
    <FooterWrapper ref={ref}>
      <CartDrawerPromoCodeWrapper>
        <CartDrawerPromoCode />
      </CartDrawerPromoCodeWrapper>
      <NewCartDrawerSummary />
      <CheckoutButtonWrapper showOutOfStockLabel={showOutOfStockLabel}>
        {checkoutButton}
      </CheckoutButtonWrapper>
      <CartDrawerPaypalButton />
      {showOutOfStockLabel && (
        <OutOfStockWrapper>
          <ErrorIcon type="error" size={14} />
          <ErrorMessage>
            <FormattedMessage
              id="global_checkout.remove_sold_out_products"
              defaultMessage="Remove Sold Out products to continue"
            />
          </ErrorMessage>
        </OutOfStockWrapper>
      )}
    </FooterWrapper>
  );
}
